/** Aperçu = HTML écran. Imprimer une pièce scellée = le PDF d’archive. */
import { printHtmlUrl, printPdfUrl } from "../../pdf/printSheet";
import { getFacturxApiBase } from "../../suiteSession";

export function quotePrintUrl(id: number, embed = true): string {
  return `${getFacturxApiBase()}/document-print.php?id=${id}${embed ? "&embed=1" : ""}`;
}

export function quoteIntegrityPrintUrl(id: number): string {
  return `${getFacturxApiBase()}/document-integrity-print.php?id=${id}&embed=1`;
}

export function quoteArchiveUrl(id: number, inline = false): string {
  return `${getFacturxApiBase()}/document-archive.php?id=${id}${inline ? "&inline=1" : ""}`;
}

export function quoteClientPdfUrl(id: number, inline = true): string {
  return `${getFacturxApiBase()}/document-pdf.php?id=${id}${inline ? "&inline=1" : ""}`;
}

export function openQuoteArchive(id: number): void {
  window.open(quoteArchiveUrl(id), "_blank", "noopener");
}

export function printQuotePdf(
  id: number,
  frame?: HTMLIFrameElement | null,
  fileTitle?: string,
  archived?: boolean,
  signed?: boolean,
): void {
  if (archived || signed) {
    printPdfUrl(quoteClientPdfUrl(id), fileTitle);
    return;
  }
  printHtmlUrl(quotePrintUrl(id, true), frame, fileTitle);
}

export function printQuoteIntegrity(id: number, fileTitle?: string): void {
  printHtmlUrl(quoteIntegrityPrintUrl(id), undefined, fileTitle);
}
